import { render } from "./XIconSolidLock.vue?vue&type=template&id=c150a97a"
import script from "./XIconSolidLock.vue?vue&type=script&lang=js"
export * from "./XIconSolidLock.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidLock.vue"]])

export default __exports__